<template>
  <div class="left">
    <div class="navlist">
      <router-link
        :to="{
          path: $Router.serviceslist.path,
          query: { cateid: item.id },
        }"
        :class="item.id === cate_id ? 'on' : ''"
        v-for="(item, index) in navlist"
        :key="index"
      >
        {{ item.title }}
      </router-link>
    </div>
    <div class="conbox">
      <div class="text">
        <h1 class="h1">{{ con.title }}</h1>
        <div class="words" v-html="con.description"></div>
      </div>
      <div class="img">
        <img :src="con.cover_img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import service from './left'

export default {
  name: 'left',
  data () {
    return {
      id: 3,
      navlist: [],
      con: []
    }
  },
  computed: {
    cate_id () {
      return parseInt(this.$route.query.cateid)
    }
  },
  watch: {
    cate_id () {
      service.getColumnId(this)
    }
  },
  created () {
    service.getColumnId(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./left.scss";
</style>



// WEBPACK FOOTER //
// src/components/services/left/left.vue